import * as React from "react";
import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import { getDetalisListOfUserWordsApi } from "../../../../../../services/userSaveWordApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../../utils/utilsFunctions";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

export default function WordsList(props) {
  const { findQuery, handleSelectWords, selectedWords } = props;

  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);
  const [rightIds, setRightIds] = React.useState([]);
  const [allWordsLength, setAllWordsLength] = React.useState(0);
  const [moreWords, setMoreWords] = React.useState(false);
  const [page, setPage] = React.useState(1);

  const getListOfUserWordsByGroup = async (oldData) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      // console.log("oldData", oldData)
      if (oldData) {
        setRight(oldData)
        let ids = []
        oldData.forEach((w) => {
          ids.push(w["_id"])
        })
        setRightIds(ids)
      }

      const response = await getDetalisListOfUserWordsApi(findQuery, { perPage: 50, page })
      let res = checkResponseData(response);
      if (res["data"] && res["data"]["docs"]) {
        toast.update(toastMsg, { render: res["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });

        // console.log("res", res["data"]["docs"]);
        setMoreWords(res["data"]["hasNextPage"])
        setAllWordsLength(res["data"]["totalDocs"])
        let allWords = [];
        res["data"]["docs"].forEach((wrd) => {
          let newWord = {}
          let keys = ["_id", "userId", "fromLang", "toLang", "word", "meanings", "subtitle", "translateOfSubtitle", "subtitleStartTime", "subtitleEndTime", "movieName", "season", "episode", "pictures", "levelForUser", "situation", "groups", "createdAt"]
          keys.forEach((el) => {
            if (wrd[el]) newWord[el] = wrd[el]
          })
          allWords.push(newWord);
        });
        setLeft(allWords);
        setPage(page + 1)
      } else {
        toast.update(toastMsg, { render: res["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });

      }
    } catch (error) {
      console.log(error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    let uniqueWord = leftChecked.filter((wrd) => !rightIds.includes(wrd["_id"]))
    let dataRight = right.concat(uniqueWord)
    let ids = [...rightIds]
    uniqueWord.forEach((w) => {
      ids.push(w["_id"])
    })
    setRightIds(ids)
    setRight(dataRight);
    handleSelectWords(dataRight)
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    let ids = [...rightIds]
    // console.log("rightIdsrightIds",ids)
    rightChecked.forEach((w) => {
      const index = ids.indexOf(w["_id"]);
      if (index > -1) {
        ids.splice(index, 1);
      }
    })
    setRightIds(ids)
    let dataRight = not(right, rightChecked)
    setRight(dataRight);
    handleSelectWords(dataRight)
    setChecked(not(checked, rightChecked));
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              "aria-label": "all items selected",
            }}
          />
        }
        title={title}
        // subheader={`${numberOfChecked(items)}/${items.length} selected`}
        subheader={`تعداد: ${items.length}`}
      />
      <Divider />
      <List
        sx={{
          width: 200,
          height: 230,
          bgcolor: "background.paper",
          overflow: "auto",
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value, index) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItem
              key={`${value}-${index}`}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    "aria-labelledby": labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                primary={`${value["word"]}`}
              />
            </ListItem>
          );
        })}
      </List>
    </Card>
  );

  useEffect(() => {
    getListOfUserWordsByGroup(selectedWords);
  }, []);

  return (
    <Grid
      sx={{ height: "100%", overflowY: "scroll", mt: 1 }}
      container
      spacing={2}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>{customList("لیست لغات", left)}
        <Button
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={() => { getListOfUserWordsByGroup(false) }}
          disabled={!moreWords}
          aria-label="move selected left"
        >
          {/* {`50 لغت دیگر ${allWordsLength} لغت`} */}
          {`بقیه لغات`}
        </Button></Grid>
      <Grid item>

        <Grid container direction="column" alignItems="center">
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>

        </Grid>
      </Grid>
      <Grid item>{customList("لغات انتخاب شده", right)}
        <Button
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={handleCheckedLeft}
          disabled={true}
          aria-label="move selected left"
        >
          {`${right.length} لغت از ${allWordsLength} لغت`}
        </Button></Grid>
    </Grid>
  );
}
